// TODO: replace these with the real store details.
const STORES = [
  {
    region: "Secunderabad",
    company: "Sachdev Sports Co. Pvt. Ltd. (Extn-1)",
    address: ["Mahatma Gandhi Rd, near Paradise Restaurant, opp. to Chermas, Kalasiguda, Secunderabad, Telangana 500003"],
    phones: ["+91-8008127860"],
    email: "info@sachdevgroup.in",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.422083551069!2d78.4885358!3d17.4395007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a1a9c8f3d0f%3A0xb46ef6073f52021d!2sSachdev%20Sports%20Co.%20Pvt.%20Ltd.%20(Extn-1)%20-%20The%20Complete%20Sports%20and%20Fitness%20Equipment%20Store.!5e0!3m2!1sen!2sin!4v1790144224685!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/oV92ZT9bE6Gw2aYf6",
  },
  {
    region: "Chennai",
    company: "Maspro Sports India",
    address: ["4/8, Wallahjah Rd, opp. new state guest house, Chepauk, Triplicane, Chennai, Tamil Nadu 600002"],
    phones: ["+91-7708774944"],
    email: "xxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.5402817485847!2d80.2780044!3d13.0649082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5268a754e00c31%3A0x7f74eb52f17f0732!2sMaspro%20Sports%20india!5e0!3m2!1sen!2sin!4v1790146947121!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/UompvfqTZJnonpKk6",
  },
  {
    region: "Chennai",
    company: "Kings Sports",
    address: ["5, New Colony Main Rd, New Colony, Adambakkam, Chennai, Tamil Nadu 600088"],
    phones: ["+91-90435 81808"],
    email: "kingslykings09@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.7325828712746!2d80.19916907585727!3d12.988948314496131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267588683fc7f%3A0x1f44cde656239fc4!2sKings%20Sports!5e0!3m2!1sen!2sin!4v1790151827805!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/Y3qttSriMAME6YHC9",
  },
  {
    region: "Visakhapatnam",
    company: "CRICZONE",
    address: ["beside Krishna College Road, opp. Union Bank of India, Bhanu Nagar, Maddilapalem, Visakhapatnam, Andhra Pradesh 530022"],
    phones: ["+91-97049 99933"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.081002054488!2d83.32057667591559!3d17.740822092525836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3943af8d31fd99%3A0x9067dff1c17034e0!2sCRICZONE!5e0!3m2!1sen!2sin!4v1790152776373!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/z3dMTfJAeirWYjPw8",
  },
  {
    region: "Visakhapatnam",
    company: "JUST CRICKET",
    address: ["54-1-11, opp. MY RESTAURANTS, Kranthi Nagar, Isukathota, Maddilapalem, Visakhapatnam, Andhra Pradesh 530022"],
    phones: ["+91-94931 81317"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.0884306655316!2d83.32404077591553!3d17.740471992536136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a39430c7baa6867%3A0x8ada96fd7d116651!2sJUST%20CRICKET%20VISAKHAPATNAM!5e0!3m2!1sen!2sin!4v1790153529369!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/i9TX5z7kCiqMeDht8",
  },
  {
    region: "Gajuwaka",
    company: "Manoj Sports",
    address: ["BC Rd, opp. Canara Bank & Reliance Fresh Smart point, New Gajuwaka, Gajuwaka, Andhra Pradesh 530026"],
    phones: ["+91-93462 44181"],
    email: "info@sachdevgroup.in",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.3013023367644!2d83.21388067591472!3d17.683221094214044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3969af9a832457%3A0xa60afdf61e7a839c!2sManoj%20Sports%20and%20Enterprises!5e0!3m2!1sen!2sin!4v1790223512109!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/8JLQSc1wx1fh942CA",
  },
  {
    region: "Bhubaneswar",
    company: "Sports Emporium",
    address: ["Plot No 24, Unit 1, Bhubaneswar, Opposite Venus Next Hotel, Choudhury Market, Bhubaneshwar-751009, Odisha"],
    phones: ["+91-6742303733"],
    email: "xxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29940.43903038214!2d85.81289011759563!3d20.27728720232862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a7310f2c71a7%3A0x1ea4ec56b02e7173!2ssports%20emporium!5e0!3m2!1sen!2sin!4v1790224042264!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/YkidPQKZKNkJ2UwU9",
  },
  {
    region: "Bengaluru",
    company: "Vishal Marketing",
    address: ["5, New Colony Main Rd, New Colony, Adambakkam, Chennai, Tamil Nadu 600088"],
    phones: ["+91-90435 81808"],
    email: "kingslykings09@gmail.com",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.7325828712746!2d80.19916907585727!3d12.988948314496131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267588683fc7f%3A0x1f44cde656239fc4!2sKings%20Sports!5e0!3m2!1sen!2sin!4v1790151827805!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/Y3qttSriMAME6YHC9",
  },
  {
    region: "Kochi",
    company: "Cricket Shack",
    address: ["2nd Floor, Tharayil Tower, NH Bypass, above Indusind Bank, Vyttila, Kochi, Ernakulam, Keralam 682019"],
    phones: ["+91-8848427010"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4835.277009428771!2d76.3185464!3d9.965377899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7eff45ad2be3d%3A0x66d15d4199e7dba4!2sCricket%20Shack!5e1!3m2!1sen!2sin!4v1790226997379!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/qie8aAV78JcNLjn59",
  },
  {
    region: "Jaipur",
    company: "Adarsh Sports",
    address: ["12B, Govind Marg, Anand Puri, Bees Dukan, Adarsh Nagar, Jaipur, Jaipur Nagar Nigam Area, Rajasthan 302004"],
    phones: ["+91-99297 22133"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4378.233940040401!2d75.82228687609395!3d26.897662160735813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db695aab5a725%3A0x20104827bb35e2ca!2sAdarsh%20Sports!5e1!3m2!1sen!2sin!4v1790228674663!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/RteyQCdgkDTNaUCv5",
  },
  {
    region: "Bhopal",
    company: "Kohli Sports & Enterprises",
    address: ["Shop No 20/23, Near Model School, Main Road, Jawahar Chowk, Bhopal-462003, Madhya Pradesh"],
    phones: ["+91-99933 19603"],
    email: "xxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d281.9528312117837!2d77.39657144683834!3d23.23282694304674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c6825f9c9853b%3A0xebd5889014b92cc9!2sKohli%20Sports%20And%20Enterprises!5e1!3m2!1sen!2sin!4v1790229461768!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/m1yk1mPUBdot5wcm9",
  },
  {
    region: "Lucknow",
    company: "Styles & Sports",
    address: ["Vinay Khand 3, Gomti Nagar, Lucknow, Uttar Pradesh 226010"],
    phones: ["+91-80520 00007"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4379.7395565391835!2d81.00507929999999!3d26.858795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be31f22938131%3A0xaa5586e6619c0c0!2sStyles%20%26%20Sports!5e1!3m2!1sen!2sin!4v1790230004408!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/YsHA479CFcmbU1b28",
  },
  {
    region: "Merrut",
    company: "Amitco Khel Industries",
    address: ["65, Saraswati Mandir, Suraj Kund Rd, Suraj Kund, Devi Nagar, Meerut, Uttar Pradesh 250001"],
    phones: ["+91-78307 83056"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d268.4228373622224!2d77.71456292182431!3d28.97702687695816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c64ef1cb0a5f3%3A0x728331b847fb02e9!2sAmitco%20Khel%20Industries!5e1!3m2!1sen!2sin!4v1790230275709!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/chedBkGZv25jxocj8",
  },
  {
    region: "Jodhpur",
    company: "Vania Sports",
    address: ["Ansal Royal Plaza, 48 Satdium Shopping Centre, Girdhar Mandir Road, behind Old McDonald's, opp. Hotel Zeelan Palace, Jodhpur, Rajasthan 342001"],
    phones: ["+91-9929171000"],
    email: "xxxxxxxxxxxxxxxxxx",
    mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4401.56739180323!2d73.0254565760794!3d26.289339586600413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418dad26aa8dc5%3A0xb0a8d57640c8352b!2sCYCLEZ%20-%20Bike%20Studio%20Bicycle%20Sales%20%26%20Service!5e1!3m2!1sen!2sin!4v1790325322202!5m2!1sen!2sin",
    mapLink: "https://maps.app.goo.gl/LrmPnMqgoSWc7PTx9",
  },
];

// ── Design tokens ─────────────────────────────────────────────────────────────
// Load these two families on the page this component is used on:
//   <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
const DISPLAY_FONT = "'Oswald', 'Arial Narrow', sans-serif";
const BODY_FONT = "'Inter', -apple-system, 'Segoe UI', sans-serif";

const PAGE = "#FAFAF7";
const CARD = "#FFFFFF";
const INK = "#181B21";
const STEEL = "#6B7280";
const MUTED = "#3F444D";
const HAIRLINE = "#E7E5DD";
const WATERMARK = "#dfd8bb";
const SIGNAL = "#D6272C";

// ── Icons (thin stroke, not filled — quieter next to the bold headlines) ──────

function PinIcon({ className = "" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 21s7-7.58 7-12a7 7 0 1 0-14 0c0 4.42 7 12 7 12z" />
      <circle cx="12" cy="9" r="2.4" />
    </svg>
  );
}

function PhoneIcon({ className = "" }) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.68 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.32 1.85.55 2.81.68A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function MailIcon({ className = "" }) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 6-10 7L2 6" />
    </svg>
  );
}

function ArrowIcon({ className = "" }) {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M7 17 17 7M9 7h8v8" />
    </svg>
  );
}

// ── Sub-components ────────────────────────────────────────────────────────────

function StoreCard({ item, index }) {
  const tag = String(index + 1).padStart(2, "0");

  return (
    <div
      className="relative flex flex-col h-full overflow-hidden rounded-2xl border"
      style={{ backgroundColor: CARD, borderColor: HAIRLINE }}
    >
      {/* scoreboard stripe */}
      <div className="h-[3px] w-full" style={{ backgroundColor: SIGNAL }} />

      {/* jersey-number watermark */}
      <span
        aria-hidden="true"
        className="absolute -top-2 right-3 text-[4.5rem] leading-none select-none pointer-events-none"
        style={{ fontFamily: DISPLAY_FONT, color: WATERMARK, fontWeight: 600 }}
      >
        {tag}
      </span>

      <div className="relative p-7 flex flex-col flex-1">
        <h3
          className="text-[1.85rem] leading-[1.05] mb-1"
          style={{ fontFamily: DISPLAY_FONT, color: INK, fontWeight: 600 }}
        >
          {item.region}
        </h3>
        <p className="text-sm mb-5" style={{ fontFamily: BODY_FONT, color: STEEL }}>
          {item.company}
        </p>

        {/* address block, styled like a ticket stub */}
        <div
          className="flex gap-2.5 pl-3 mb-6 border-l"
          style={{ borderColor: SIGNAL, borderLeftStyle: "dashed" }}
        >
          <PinIcon className="shrink-0 mt-0.5" style={{ color: STEEL }} />
          <p className="text-[0.875rem] leading-relaxed" style={{ fontFamily: BODY_FONT, color: MUTED }}>
            {item.address.join(", ")}
          </p>
        </div>

        <div className="space-y-2 mt-auto" style={{ fontFamily: BODY_FONT }}>
          {item.phones.map((p, i) => (
            <a
              key={i}
              href={`tel:${p.replace(/[^\d+]/g, "")}`}
              className="flex items-center gap-2.5 text-[0.875rem] w-fit transition-colors"
              style={{ color: MUTED }}
              onMouseEnter={(e) => (e.currentTarget.style.color = SIGNAL)}
              onMouseLeave={(e) => (e.currentTarget.style.color = MUTED)}
            >
              <PhoneIcon style={{ color: STEEL }} />
              {p.trim()}
            </a>
          ))}
          {/* {item.email && (
            <p
              className="flex items-center gap-2.5 text-[0.875rem] w-fit transition-colors"
              style={{ color: MUTED }}
              onMouseEnter={(e) => (e.currentTarget.style.color = SIGNAL)}
              onMouseLeave={(e) => (e.currentTarget.style.color = MUTED)}
            >
              <MailIcon style={{ color: STEEL }} />
              {item.email}
            </p>
          )} */}
        </div>

        {item.mapLink && (
          <a
            href={item.mapLink}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 mt-6 pt-5 text-[0.8rem] tracking-wide border-t transition-colors w-fit"
            style={{ fontFamily: BODY_FONT, color: STEEL, borderColor: HAIRLINE }}
            onMouseEnter={(e) => (e.currentTarget.style.color = SIGNAL)}
            onMouseLeave={(e) => (e.currentTarget.style.color = STEEL)}
          >
            Get directions
            <ArrowIcon />
          </a>
        )}
      </div>
    </div>
  );
}

// ── Main Page ─────────────────────────────────────────────────────────────────

export default function AuthDealers() {
  return (
    <div style={{ backgroundColor: PAGE }}>
      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-10">
        <h1
          className="text-[2.6rem] md:text-5xl leading-[0.97] max-w-3xl"
          style={{ fontFamily: DISPLAY_FONT, color: INK, fontWeight: 600 }}
        >
          Walk into a TYKA 
        </h1>
        <p
          className="mt-4 max-w-xl text-base md:text-lg"
          style={{ fontFamily: BODY_FONT, color: STEEL }}
        >
          Authorized dealers across India that carry the full TYKA range.
        </p>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-10 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {STORES.map((item, i) => (
            <StoreCard key={item.region} item={item} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}